import { render, staticRenderFns } from "./stockmgt.vue?vue&type=template&id=7c32c419&scoped=true"
import script from "./stockmgt.vue?vue&type=script&lang=js"
export * from "./stockmgt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c32c419",
  null
  
)

export default component.exports